import type * as Item from "../../lib/models/item.server.ts"
import type * as LeasedTag from "../../lib/models/leased-tag.server.ts"

import * as ItemsGrid from "../../lib/ui/items-grid.tsx"

import { useLang } from "../../lib/lang/use-lang.ts"
import { AsyncUserOwnedItemIndicator } from "./user-owned-item.tsx"

export const OtherChippedItems = ({
  items,
  currentUserOwnedItemsPromise,
}: {
  items: Item.ProfilePreview[]
  currentUserOwnedItemsPromise: ReturnType<typeof LeasedTag.getFromUserGroupedByProduct>
}) => {
  const lang = useLang()
  if (items.length === 0) {
    return null
  }

  return (
    <>
      <ItemsGrid.Header className="bshadow-t bshadow-gray-6">
        <p className="text-xs-upper">{lang.terms.OTHER_CHIPPED_ITEMS}</p>
      </ItemsGrid.Header>
      <ItemsGrid.Grid className="grid-cols-2 md:grid-cols-4 gap-x-3 gap-y-6 md:gap-10">
        {items
          .filter((item) => item !== null)
          .map((item) => (
            <ItemsGrid.Item
              key={item.id}
              to={`/creators/${item.team.urlSlug}/items/${item.id}`}
              mediaUrl={item.imageUrl}
              creator={item.team.name}
              name={item.name}
              shopifyProductData={item.shopifyProductData}
            >
              <AsyncUserOwnedItemIndicator
                itemId={item.id}
                currentUserOwnedItemsPromise={currentUserOwnedItemsPromise}
              />
            </ItemsGrid.Item>
          ))}
      </ItemsGrid.Grid>
    </>
  )
}
